import { useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Box } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';

import Context from '../../Context';

interface ItemProps {
  x?: number;
}

/**
 * Implicitly use React's portal to inject a card in the recap top bar
 * without loosing events, data or lifecycle
 */
const Item: FCWithChildren<ItemProps> = ({ children, x }) => {
  const { containerRef, onPositionChange } = useContext(Context);

  useEffect(() => {
    if (x) {
      onPositionChange(x);
    }
  }, [onPositionChange, x]);

  return (
    containerRef.current &&
    createPortal(<Box padding="space-16">{children}</Box>, containerRef.current)
  );
};

export default Item;
